function injectGoogleTagScriptForAds() {
    var gads = document.createElement('script');
    gads.type = 'text/javascript';
    gads.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';
    gads.async = true;

    if (typeof OneTrust !== 'undefined') {
        OneTrust.OnConsentChanged(function () {
            location.reload();
        });

        if (!oneTrustRequired()) {
            gads.class = "optanon-category-C0004";
            gads.type = "text/plain";
        }
    }

    var node = document.getElementsByTagName('script')[0];
    node.parentNode.insertBefore(gads, node);
}

function oneTrustRequired() {
    let categories = ['C0004', 'C0002', 'C0003'];
    for (var i = 0; i < categories.length; i++) {
        if (!OnetrustActiveGroups.includes(categories[i])) {
            return false;
        }
    }
    return true;
}